import React from "react";
import Map from "../common/Map/Map";
import Three from "../common/Three/Three";
import Info from "./Info/Info";
import PropTypes from 'prop-types';

import AppBar from "@material-ui/core/AppBar/AppBar";
import Toolbar from "@material-ui/core/Toolbar/Toolbar";
import Typography from "@material-ui/core/Typography/Typography";

import {
    DesktopWrapper,
    GenerateProgress,
    GridContainer,
    InfoAndThreeWrapper,
    InfoWrapper,
    MapWrapper,
    ThreeGridWrapper
} from "./Desktop.sc";


const Desktop = (props) => {

    const {
        lat, lng, boxSize, boxScale, waterDrop, baseHeight, verticalScale, modelScale,
        loadingComplete, model, zoom, handleBaseHeightChange, handleBoxScaleChange, handleBoxSizeChange,
        handleLocationChange, handleVerticalScaleChange, handleWaterDropChange, handleModelScaleChange,
        onBoxChange, onClickGenerate, onClickDownload, showDownloadButtons
    } = props;

    return (
        <DesktopWrapper>
            <AppBar position="static" color="default">
                <Toolbar>
                    <Typography variant="title" color="inherit">
                        Create and download 3d printable STL models of any region on Earth
                    </Typography>
                </Toolbar>
            </AppBar>
            {!loadingComplete && <GenerateProgress/>}
            <GridContainer
                container
                spacing={0}
            >
                <MapWrapper
                    item
                    xs={12}
                    sm={6}
                >
                    <Map
                        onBoxChanged={(lat, lng) => onBoxChange(lat, lng, boxSize, boxScale)}
                        lat={lat}
                        lng={lng}
                        defaultZoom={zoom}
                        boxSize={boxSize}
                        boxScale={boxScale}
                    />
                </MapWrapper>
                <InfoAndThreeWrapper
                    container
                    spacing={0}
                    item
                    xs={12}
                    sm={6}
                >
                    <InfoWrapper
                        item
                        xs={12}
                    >
                        <Info
                            verticalScale={verticalScale}
                            baseHeight={baseHeight}
                            waterDrop={waterDrop}
                            handleOnClickGenerate={onClickGenerate}
                            handleOnClickDownload={onClickDownload}
                            handleBoxSizeChange={handleBoxSizeChange}
                            handleLocationChange={handleLocationChange}
                            handleBoxScaleChange={handleBoxScaleChange}
                            handleWaterDropChange={handleWaterDropChange}
                            handleBaseHeightChange={handleBaseHeightChange}
                            handleVerticalScaleChange={handleVerticalScaleChange}
                            handleModelScaleChange={handleModelScaleChange}
                            lat={lat}
                            lng={lng}
                            modelScale={modelScale}
                            boxSize={boxSize}
                            boxScale={boxScale}
                            downloadAvailable={typeof model !== 'undefined'}
                            loadingComplete={loadingComplete}
                            showDownloadButton={showDownloadButtons}
                        />
                    </InfoWrapper>
                    <ThreeGridWrapper
                        item
                        xs={12}
                    >
                        <Three
                            model={model}
                            showLegalWrapper={true}
                        />
                    </ThreeGridWrapper>
                </InfoAndThreeWrapper>
            </GridContainer>
        </DesktopWrapper>
    )
};

Desktop.propTypes = {
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
    boxSize: PropTypes.number.isRequired,
    boxScale: PropTypes.number.isRequired,
    waterDrop: PropTypes.number.isRequired,
    baseHeight: PropTypes.number.isRequired,
    verticalScale: PropTypes.number.isRequired,
    modelScale: PropTypes.number.isRequired,
    loadingComplete: PropTypes.bool.isRequired,

    model: PropTypes.object,
    zoom: PropTypes.number.isRequired,

    handleBaseHeightChange: PropTypes.func.isRequired,
    handleBoxScaleChange: PropTypes.func.isRequired,
    handleBoxSizeChange: PropTypes.func.isRequired,
    handleLocationChange: PropTypes.func.isRequired,
    handleVerticalScaleChange: PropTypes.func.isRequired,
    handleWaterDropChange: PropTypes.func.isRequired,
    handleModelScaleChange: PropTypes.func.isRequired,
    onBoxChange: PropTypes.func.isRequired,
    onClickGenerate: PropTypes.func.isRequired,
    onClickDownload: PropTypes.func.isRequired,
    showDownloadButtons: PropTypes.bool.isRequired
};

export default Desktop;



// WEBPACK FOOTER //
// ./src/desktop/Desktop.js